import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { SortConfig } from '../view-models/sort-config';

@Directive({
	selector: '[sortableHeader]'
})
export class SortableHeaderDirective {
	@Input() sortableHeader!: string;
	@Input() currentSort?: SortConfig;
	@Output() sort = new EventEmitter<SortConfig>();

	constructor(private el: ElementRef) {
		this.el.nativeElement.style.cursor = 'pointer';
	}

	@HostListener('click')
	onClick() {
		const newDirection = this.currentSort?.column !== this.sortableHeader ? 'asc' : this.currentSort.direction === 'asc' ? 'desc' : 'asc';

		this.sort.emit({
			column: this.sortableHeader,
			direction: newDirection as 'asc' | 'desc'
		});
	}
}
